module.exports = __webpack_public_path__ + "e652f6044e8fbd24bfa3685d3203def0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/rs6/bank1.png
// module id = 1078
// module chunks = 0